import { formatSenderApiError } from '@/lib/format-sender-api-error';
import axios from 'axios';

export function resolveSenderActionError(error: unknown, fallback: string): string {
	if (axios.isAxiosError(error)) {
		return (
			formatSenderApiError(error.response?.data, error.response?.status) || error.message || fallback
		);
	}
	return fallback;
}
